var _circle, _rect, _path, _ellipse, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoHistoryIcon = function SvgNoHistoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 52,
    fill: "none",
    viewBox: "0 0 61 52"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.133,
    cy: 25.133,
    r: 25.133,
    fill: "#E5E5FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.667,
    height: 44.067,
    x: 15.367,
    y: 7.433,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M23.533 16.033h17.334M23.533 24.7h17.334M23.533 33.367h13"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 37,
    fill: "#fff",
    rx: 11.5,
    ry: 12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 10.304,
    fill: "#fff",
    stroke: "#3D4355",
    transform: "matrix(-1 0 0 1 49.804 36.804)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "m53.726 40.725-3.922-3.46v-6.343"
  })));
};
export default SvgNoHistoryIcon;